module.exports = __webpack_public_path__ + "img/icon-attach.2502e6ce.png";